import {Box, Grid, CircularProgress} from "@mui/material";
import Colors from "./ui/Colors";

const CustomLoader = () => {
    return (
        <Box 
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: "100vh", // Full viewport height
                position: "fixed", // Fixed position
                top: 0,
                left: 0,
                backgroundColor: "rgba(255, 255, 255, 0.9)", // Semi-transparent white background
                zIndex: 9999 // Ensure it's above other content
            }}
        >
            <Grid 
                container 
                direction="column" 
                alignItems="center" 
                spacing={4} // Add space between elements
                sx={{
                    maxWidth: "300px", // Limit width for larger screens
                    margin: "auto"
                }}
            >
                <Grid item>
                    <Box 
                        component="img" 
                        sx={{ 
                            width: { xs: "180px", sm: "200px", md: "220px" },
                            height: "auto",
                            animation: "pulse 2s infinite", // Add subtle animation
                            "@keyframes pulse": {
                                "0%": { opacity: 0.8 },
                                "50%": { opacity: 1 },
                                "100%": { opacity: 0.8 }
                            }
                        }} 
                        alt="Logo" 
                        src="/images/logo_datalove.png" 
                    />
                </Grid>
                <Grid item>
                    <CircularProgress 
                        sx={{
                            color: Colors.primary,
                            width: "50px !important",
                            height: "50px !important"
                        }} 
                    />
                </Grid>
            </Grid>
        </Box>
    )
}

export default CustomLoader;